import { H6, ResponsiveTable, ResponsiveTableRow, Separator } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import ChangeHistoryRow from './ChangeHistoryRow'

const containerCss = css`
  margin-top: 1.875rem;
`

const HistoryChangeList = ({ changes, title }) => {
  const { t } = useTranslation()

  return (
    <div css={containerCss}>
      {title && (
        <>
          <H6>{title}</H6>
          <Separator size="nano" />
        </>
      )}
      <ResponsiveTable
        totalColumnCount={3}
        atSizeColumns={{
          default: {
            labels: [
              t('history-viewer.changes-table.change.label', 'Change'),
              t('history-viewer.changes-table.value.label', 'Value'),
              t('history-viewer.changes-table.date.label', 'Date'),
            ],
          },
        }}
      >
        {changes.length > 0 &&
          changes.map((change) => (
            <ChangeHistoryRow key={`${change.actionId}_${change.sequenceNumber}`} change={change} />
          ))}
        {changes.length === 0 && (
          <ResponsiveTableRow
            column1={t('history-viewer.filter.no-results', 'No changes exist for the selected filter.')}
            column1span={3}
          />
        )}
      </ResponsiveTable>
    </div>
  )
}

export default HistoryChangeList
